import {createSignal, onMount,JSX, Component, Show } from 'solid-js';
import { render } from "solid-js/web";
import {getOrSetAsync } from './API';
import {CMS} from './cms';
import { InfoWindow } from './DepictedPlaceInfoWindow';
import {HeatmapDto, Map, MarkerDto} from './Map';
import { ArtworkLocation } from './Types';

type Props = {
    data: ArtworkLocation;
    onBackToArtworksClicked: () => void;
}

export const DepictedPlacesTab : Component<Props> = (props) => {
    const [data, setData] = createSignal<{ markers: any[]; heatmap: any[] }|null>(null);
    const [mapMode, setMapMode] = createSignal<string>("markers");
    const [mapWidth] = createSignal<string>("100%");
    const [mapHeight] = createSignal<string>("600px");
    const [hasMapData, setHasMapData] = createSignal<boolean>(false);
    const setMarkerMode = (e: Event) => {
        e.preventDefault();
        setMapMode("markers");
    };
    const setHeatmapMode = (e: Event) => {
        e.preventDefault();
        setMapMode("heatmap");
    };
    const markerLinkColour = () => mapMode() === "markers" ? "red" : "#efefef";
    const heatmapLinkColour = () => mapMode() === "heatmap" ? "red" : "#efefef";
    const getMapData = async ()  => {
        const json = await getOrSetAsync("depicted-places:markers-and-heatmap/" + props.data.Id, async () => {
            const response = await fetch("/ArtCollection/GetDepictedPlacesJson?id=" + props.data.Id);
            const json = await response.json();
            return json;
        });
        return json;
    };
    const renderToNode = (jsx: JSX.Element) => {
        const node = document.createElement("DIV");
        render(() => jsx, node);
        return node;
    };
    const onMarkerClicked = async (marker: google.maps.Marker, map: google.maps.Map) => {
        const jsx = InfoWindow(marker.data as MarkerDto);
        const content = renderToNode(jsx);
        const infowindow = new google.maps.InfoWindow({ content, maxWidth: 850 });
        infowindow.open(map, marker);
    };
    const loadMap = async () => {
        console.log("loadMap");
        const json = await getMapData();
        const markers = json.Data.map((x: any) => {
            return {
                Name: x.DepictedAddress.Name,
                Latitude: x.DepictedAddress.Latitude,
                Longitude: x.DepictedAddress.Longitude
            } as MarkerDto;
        }) as MarkerDto[];
        const heatmap = json.Data.map((x: any) =>{
            return {
                Latitude: x.DepictedAddress.Latitude,
                Longitude: x.DepictedAddress.Longitude,
                Weight: x.ArtworksTotal
            } as HeatmapDto;
        }) as HeatmapDto[];
        console.log({markers, heatmap});
        setData({ markers, heatmap });
        setHasMapData(true);
    };
    onMount(async () => {
        await loadMap();
    });    
return (
<>
    <div style="color: #efefef; background-color: #333; text-align: left; padding: 20px;">
        <h3 style="font-family: 'Impact'; letter-spacing: 0.15rem; padding-bottom: 20px;">
            Location of places depicted by artworks at the <b>{props.data.Name}</b>
        </h3>
        <div style="margin-bottom: 20px;">
            <div onClick={(e) => setMarkerMode(e) } style="display: inline-block; margin-right: 20px;">
                <div style="position: relative; left: 15px;">
                    <span class="glyphicon glyphicon-map-marker" style={{ "font-size": "2em", "color": "red" }}></span>
                </div>
                <div style={{ "font-family": "Oswald", "font-size": "1em", "letter-spacing": "0.1em", "color": markerLinkColour() }}>
                    <CMS id="label::map">markers</CMS>
                </div>
            </div>
            <div onClick={(e) => setHeatmapMode(e) } style="display: inline-block;">
            <div style="position: relative; left: 15px; top: -5px;">
                    <img src="/images/icons/heatmap.png" style="height: 30px; width: 30px;" />
                </div>
                <div style={{ "font-family": "Oswald", "font-size": "1em", "letter-spacing": "0.1em", "color": heatmapLinkColour() }}>
                    <CMS id="label::map">heatmap</CMS>
                </div>
            </div>
        </div>
        <p style="color: #efefef; border-top: 2px dotted #efefef; padding: 10px 20px; margin: 0; font-size: 1.5em;" onClick={props.onBackToArtworksClicked}>
            <span class="fa fa-arrow-circle-left" style="margin-right: 10px;"></span> <CMS id="button::back-to-the-artworks">back to the artworks</CMS>
        </p>
    </div>
    <Show when={hasMapData()}>
        <Map
            width={mapWidth} height={mapHeight}
            data={data}
            onMarkerClicked={onMarkerClicked}
            mode={mapMode}
        />
    </Show>
</>);
}